<template>
    <div>
        <div class="contain">
            <div class="container-terms pl-4">
                <div class="container">
                    <h1 class="mt-5">Terms of Service
                        <hr class="mt-0" style="width:10%;text-align:left;margin-left:0;background-color:#136ACD;border-width:3px;border-radius:2px">
                    </h1>

              </div>
            
            </div>
            <div class="terms-body container pb-lg--5 pl-lg-5 pr-lg-5">
                <div class="cirle-container">
                <span class="dot mt-2"></span> <h1 class="ml-2" style="font-size:22px; font-weight:bold">Privacy Policy</h1>
                </div>
                <p class="ml-4" style="text-align:justify">
                    Complustech Limited built the ChurchPlus app as a Free app. This SERVICE is provided by Complustech Limited at no cost and is intended for use as is.

This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.

If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.

The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at ChurchPlus unless otherwise defined in this Privacy Policy.
                
                </p>
                <div class="cirle-container">
                <span class="dot mt-2"></span> <h1 class="ml-2" style="font-size:22px; font-weight:bold">Information Collection and Use</h1>
                </div>
                <p class="ml-4" style="text-align:justify">
                    For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to Email, Username, Phone Number. The information that we request will be retained by us and used as described in this privacy policy.

The app does use third party services that may collect information used to identify you.

Link to privacy policy of third party service providers used by the app
                
                </p>
                <div class="cirle-container ml-5">
                 <span class="dot1 mt-2"></span><router-link to=""><h1 style="font-size:16px; font-weight:bold; text-decoration:underline" class="ml-2">Google Play Services</h1></router-link>
                </div>
                 <div class="cirle-container">
                <span class="dot mt-2"></span> <h1 class="ml-2" style="font-size:22px; font-weight:bold">Log Data</h1>
                </div>
                <p class="ml-4" style="text-align:justify">
                    We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
                </p>
                 <div class="cirle-container">
                <span class="dot mt-2"></span> <h1 class="ml-2" style="font-size:22px; font-weight:bold">Cookies</h1>
                </div>
                <p class="ml-4" style="text-align:justify">
                    Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.

This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.
                </p>
                 <div class="cirle-container">
                <span class="dot mt-2"></span> <h1 class="ml-2" style="font-size:22px; font-weight:bold">Service Providers</h1>
                </div>
                <p class="ml-4" style="text-align:justify">
                    We may employ third-party companies and individuals due to the following reasons:
                </p>
                <div class="cirle-container ml-5">
                 <span class="dot1 mt-2"></span><h1 style="font-size:16px;" class="ml-2">To facilitate our Service;</h1>
                 
                </div>
                <div class="cirle-container ml-5">
                 <span class="dot1 mt-2"></span><h1 style="font-size:16px;" class="ml-2">To provide the Service on our behalf;</h1>
                 
                </div>
                <div class="cirle-container ml-5">
                 <span class="dot1 mt-2"></span><h1 style="font-size:16px;" class="ml-2">To perform Service-related services; or</h1>
                 
                </div>
                <div class="cirle-container ml-5">
                 <span class="dot1 mt-2"></span><h1 style="font-size:16px;" class="ml-2">To assist us in analyzing how our Service is used.</h1>
                
                </div>
                 <p class="ml-4" style="text-align:justify">
                   We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
                </p>
                 <div class="cirle-container">
                <span class="dot mt-2"></span> <h1 class="ml-2" style="font-size:22px; font-weight:bold">Security</h1>
                </div>
                <p class="ml-4" style="text-align:justify">
                    We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
                </p>
                 <div class="cirle-container">
                <span class="dot mt-2"></span> <h1 class="ml-2" style="font-size:22px; font-weight:bold">Links to Other Sites</h1>
                </div>
                <p class="ml-4" style="text-align:justify">
                    This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
                </p>
                <div class="cirle-container">
                <span class="dot mt-2"></span> <h1 class="ml-2" style="font-size:22px; font-weight:bold">Children’s Privacy</h1>
                </div>
                <p class="ml-4" style="text-align:justify">
                    These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.

                </p>
                <div class="cirle-container">
                <span class="dot mt-2"></span> <h1 class="ml-2" style="font-size:22px; font-weight:bold">Changes to This Privacy Policy</h1>
                </div>
                <p class="ml-4" style="text-align:justify">
                    We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.
                </p>
                <div class="cirle-container">
                <span class="dot mt-2"></span> <h1 class="ml-2" style="font-size:22px; font-weight:bold">Contact Us</h1>
                </div>
                <p class="ml-4" style="text-align:justify; margin-bottom: 90px;">
                    If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.
                </p>
                
                 
            </div>
            <div class="" style="height:60px">
                 <div class="container">
                     <div class="row bottom-button">
                         <div class="col-md-12 d-flex justify-content-end py-2">
                           <router-link to="/register"> <Button label="UNDERSTOOD" class="p-button-raised p-button-rounded"  style="font-size:14px; opacity:1; color:#ffffff; background:#136ACD; border-color: #136ACD;width:156px; height:45px" /></router-link>
                         </div>
                     </div>
                 </div>
             </div>
        </div>

    </div>
</template>

<script>
import Button from 'primevue/button';
    export default {
        components:{Button},
        data() {
            return {
                
                
            }
             
        },
        methods:{
            
        },
        created() {
       
        },
        
        
    }
</script>

<style scoped>
.contain{
background: #FFFFFF 0% 0% no-repeat padding-box;
border: 1px solid #EBEFF4;
border-radius: 20px;
opacity: 1;
width: 90%;
margin: auto;
max-width:1106px;

}
.container-terms{
background: #FFFFFF 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 15px #0000001A;
border: 1px solid #EBEFF4;
border-radius: 20px 20px 0px 0px;
opacity: 1;
width: 100%;
height: 120px;
margin-bottom: 60px;
}
.container-terms h1{
font: normal normal 800 32px/43px Nunito Sans;
letter-spacing: 0px;
color: #02172E;
opacity: 1;

}
.dot {
  height: 12px;
  width: 12px;
  background-color:#136ACD;
  border-radius: 50%;
  display: inline-block;
}
.dot1 {
  height: 6px;
  width: 6px;
  background-color:#070707;
  border-radius: 50%;
  display: inline-block;
}
.cirle-container{
display: flex;
}
.buton{
background: #FFFFFF 0% 0% no-repeat padding-box;
border: 1px solid #EBEFF4;
border-radius: 0px 0px 20px 20px;
opacity: 1;
display: flex;
justify-content:flex-end;
padding: 20px 0px;
bottom: 0;
position: fixed;
width: 58.1%;
max-width:1106px;

/* max-width: 58.1%; */
}

.bottom-button {
    border-top: 1px solid #EBEFF4;
}

.terms-body {
    max-height: calc(100vh - 260px);
    overflow: scroll;
}

@media screen and (max-width: 768px) {
    .contain {
        border: none;
        width: 100%;
    }

    .terms-body {
        width: 100%;
    }
}
/* @media only screen and (max-width: 760px) {
.buton{
width: 100%;
}
.p-button{
    right:15px;
}
.contain{
width: 100%; 

}
} */
/* @media (min-width: 761px) and (max-width:1230px) {
.buton{
width: 90%;
}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1231px) and (max-width:1256px) {
.buton{
width: 88%;
}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1257px) and (max-width:1304px) {
.buton{
width: 85.6%;
}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1305px) and (max-width:1378px) {
.buton{
width: 85%;
}
.p-button{
    right:15px;
}
}  */
/* @media (min-width: 1306px) and (max-width:1315px) {
.buton{
width: 84.4%;
}
.p-button{
    right:15px;
}
}  */
/* @media (min-width: 1316px) and (max-width:1336px) {
.buton{
width: 82.9%;
}
.p-button{
    right:15px;
}
}  */
/* @media (min-width: 1337px) and (max-width:1362px) {
.buton{
width: 81%;
}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1363px) and (max-width:1379px) {
.buton{
width: 80.9%;
}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1380px) and (max-width:1400px) {
    .buton{
        width: 80%;
    }
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1400px) and (max-width:1507px) {
.buton{
width: 90.7%;

}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1510px) and (max-width:1517px) {
.buton{
width: 73%;
}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1519px) and (max-width:1539px) {
.buton{
width: 72.8%;
}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1540px) and (max-width:1542px) {
.buton{
width: 71.8%;
}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1543px) and (max-width:1569px) {
.buton{
width: 70.9%;
}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1569px) and (max-width:1600px) {
.buton{
width: 69%;
}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1601px) and (max-width:1629px) {
.buton{
width: 67.9%;

}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1630px) and (max-width:1639px) {
.buton{
width: 67.4%;


}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1670px) and (max-width:1777px) {
.buton{
width: 70.4%;


}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1780px) and (max-width:1795px) {
.buton{
width: 70.4%;


}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1880px) and (max-width:1920px) {
.buton{
width: 57.5%;


}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 1921px) and (max-width:2000px) {
.buton{
width: 55.2%;


}
.p-button{
    right:15px;
}
} */
/* @media (min-width: 2001px) and (max-width:2050px) {
.buton{
width: 54.0%;


}
.p-button{
    right:15px;
}
} */
</style>